var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill","fillRule":"nonzero","d":"M27 0H3C1.35 0 0 1.35 0 3v24c0 1.65 1.35 3 3 3h24c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3zm-3.45 10.95c-.15 6.9-4.5 11.7-11.1 12-2.7.15-4.65-.75-6.45-1.8 1.95.3 4.5-.45 5.85-1.65-1.95-.15-3.15-1.2-3.75-2.85.6.15 1.2 0 1.65 0-1.8-.6-3-1.65-3.15-4.05.45.3 1.05.45 1.65.45-1.35-.75-2.25-3.6-1.2-5.4 1.95 2.1 4.35 3.9 8.25 4.2-1.05-4.2 4.65-6.45 6.9-3.6 1.05-.15 1.8-.6 2.55-.9-.3 1.05-.9 1.65-1.65 2.25.75-.15 1.5-.3 2.1-.6-.15.75-.9 1.35-1.65 1.95z"}));
}

TwitterInline.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
